<template>
  <transition name="fade">
    <div :class="['notification is-radiusless', cls]">
      <button class="delete" v-on:click="closeNotification" v-show="closable"></button>
      <span v-if="msg">{{ msg }}</span>
      <span v-if="HTMLmsg" v-html="HTMLmsg"></span>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'notification',
  props: ['cls', 'msg', 'fade', 'closable', 'HTMLmsg'],
  mounted () {
    if (this.fade) {
      this.autoClose()
    }
  },
  methods: {
    closeNotification () {
      this.$emit('closeNotification')
    },
    autoClose () {
      setTimeout(() => {
        this.closeNotification()
      }, 3000);
    }
  }
}
</script>
<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }
  .fade-enter, .fade-leave-to {
    transition: opacity .2s;
  }
</style>
